import { render } from "./g-account-edit.vue?vue&type=template&id=490bf482&ts=true"
import script from "./g-account-edit.vue?vue&type=script&lang=tsx"
export * from "./g-account-edit.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__